// Positions an in-page section clear of the sticky header. Used by in-page navigation and by the
// router's hash handling, so a deep link lands exactly where a click would.
export const scrollToSectionId = (id, { smooth = true } = {}) => {
  const el = document.getElementById(id);
  if (!el) return false;
  const header = document.querySelector("header")?.offsetHeight || 88;
  window.scrollTo({
    top: el.getBoundingClientRect().top + window.scrollY - header - 24,
    behavior: smooth ? "smooth" : "auto",
  });
  return true;
};
